import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-ticket-transfer-page',
  templateUrl: './ticket-transfer-page.component.html',
  styleUrls: ['./ticket-transfer-page.component.scss'],
})
export class TicketTransferPageComponent implements OnInit {
  showPastGames: boolean = true;
  showPastGamesSection: boolean = true;

  constructor() {}

  ngOnInit() {}

  togglePastGames() {
    this.showPastGames = !this.showPastGames;
  }

  shouldShowPastGameSection(count: number) {
    if (count <= 0) {
      this.showPastGamesSection = false;
    }
  }
}
